import { isProductionEnvironment, useFeatureFlags } from '@cko/dashboard-shared';

export const useDeveloperToolsEnabled = () => {
  const { getFeatureFlag } = useFeatureFlags();
  const isDeveloperToolsEnabled = getFeatureFlag('enableDashboardDevTools');

  if (isProductionEnvironment()) {
    return false;
  }

  return isDeveloperToolsEnabled;
};
